import { inject, Injectable } from '@angular/core';
import { MpsUserService } from '../../mps/services/mps-user.service';
import { applicationRouteNames } from '../application-route-names';

/**
 * Service to resolve which route a user should be redirected to based on their permissions
 */
@Injectable({
  providedIn: 'root'
})
export class RouteResolverService {
  private userService = inject(MpsUserService);

  /**
   * Route priority order with their required permissions
   */
  private routePriority: { path: string; permission: string }[] = [
    { path: applicationRouteNames.monitoring, permission: 'error-log' },
    { path: `${applicationRouteNames.monitoring}/subscription-logs`, permission: 'subscription-log' },
    { path: applicationRouteNames.subscriptionConfiguration, permission: 'subscription-configuration' },
    { path: applicationRouteNames.administration, permission: 'users-management' },
  ];

  /**
   * Get the first route the user has permission to access
   * Returns null if user has no permissions
   */
  getFirstAvailableRoute(): string | null {
    const user = this.userService.getUser();

    if (!user || !user.permissions || user.permissions.length === 0) {
      return null;
    }

    for (const route of this.routePriority) {
      if (user.permissions.includes(route.permission)) {
        return `/${route.path}`;
      }
    }

    return null;
  }

  /**
   * Check if user has at least one permission
   */
  hasAnyPermission(): boolean {
    const user = this.userService.getUser();
    return user?.permissions && user.permissions.length > 0 || false;
  }
}
